import { useCallback, useEffect, useState } from 'react';

function useDevice() {
  const MAX_MOBILE_WIDTH = 1024;

  const isClient = typeof window === 'object';

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
    };
  }, [isClient]);

  const [screenSize, setScreenSize] = useState(getSize);

  useEffect(() => {
    const handleResize = () => setScreenSize(getSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [getSize]);

  const isTouchDevice = () =>
    'ontouchstart' in window ||
    'ontouchstart' in document.documentElement ||
    navigator.maxTouchPoints > 0 ||
    (window.navigator as any).msMaxTouchPoints > 0;

  const isMobile = () => window.innerWidth <= MAX_MOBILE_WIDTH;
  const isDesktop = () => window.innerWidth > MAX_MOBILE_WIDTH;

  return {
    screenSize,
    isTouchDevice,
    isMobile,
    isDesktop,
  };
}

export default useDevice;
